import React from 'react';
export function ConventionalVsHSMSection() {
  return <section data-id="element-4219">
      <div className="bg-[#026ab7] py-4 px-6 rounded-t-xl" data-id="element-4220">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4221">
          Conventional Milling Versus High Speed Machining
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-8" data-id="element-4222">
        <div className="text-gray-700 text-lg leading-relaxed space-y-4" data-id="element-4223">
          <p data-id="element-4224">
            <strong data-id="element-4225">Conventional machining</strong> differs greatly from{' '}
            <strong data-id="element-4226">High Speed Milling</strong> in a lot of aspects. When using
            conventional machining techniques, the contact time between the tool
            and piece is much greater than it is with HSM. Conventional
            machining also involves a much greater cutting force.
          </p>
          <p data-id="element-4227">
            <strong data-id="element-4228">
              Conventional Machining will typically lead to a less accurate
              workpiece and inferior surface finish than could be achieved
              through high-speed machining.
            </strong>{' '}
            Another major difference associated with high-speed machining is the
            material removal rate is much higher.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 text-gray-700 text-base leading-relaxed space-y-4" data-id="element-4229">
          <p data-id="element-4230">
            The traditional toolpath cuts in a "racetrack" pattern, simply
            following the overall shape of the feature being machined, and the
            process itself lacks the control parameters necessary for increased
            performance.
          </p>
          <p data-id="element-4231">
            This lack of control means that the tool can encounter a varying
            amount of material – especially in the corners – that will
            negatively impact the cutter's ability for going faster. Due to the
            increased linear forces and stress on the cutter, the depth of cut,
            rpm, and feedrate must be reduced…and due to the presence of added
            friction, coolant is most often necessary for a successful outcome.
            In addition to the heat buildup caused by this friction, the
            intermittent over-engagement of the process will also cause extreme
            tool wear, and overall tool life will be much less than could be
            achieved with high speed machining practices.
          </p>
        </div>

        <div className="text-center" data-id="element-4232">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/General-properties-of-high-speed-machining-9.png" alt="General properties of high speed machining" className="mx-auto max-w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4233" />
        </div>
      </div>
    </section>;
}